<template>
  <transition name="popMenu">
    <nav class="nav">
      <a href="https://www.desivero.com/contatti" target="_blank" class="nav__block nav__block--mail">
        <img :src="returnBasePath('/assets/img/shared/icon-mail.png')" alt="Mail"/>
        <span class="nav__block__span">Scrivi</span>
      </a>
      <a
        href="https://www.smartsuppchat.com/widget?key=75428593c4d0726947a4a0163da30f962c90958b&vid=8Gn4b8DkfXixKBbF2Q6WVIEwt4jk8xZgs524431026032018&group=&lang=it&pageTitle=Desivero%20%E2%80%93%20soluzioni%20per%20il%20bagno%2C%20il%20riscaldamento%20e%20la%20climatizzazione&pageUrl=https%3A%2F%2Fwww.desivero.com%2F&domain=www.desivero.com&referer="
        target="_blank" class="nav__block nav__block--chat">
        <img :src="returnBasePath('/assets/img/shared/icon-chat.png')" alt="Chat"/>
        <span class="nav__block__span">Chatta</span></a>
      <a :href="phone" target="_blank" class="nav__block nav__block--phone">
        <img :src="returnBasePath('/assets/img/shared/icon-phone.png')" alt="Telefono"/>
        <span class="nav__block__span">0297190019</span></a>
      <a href="https://www.desivero.com/privacy-policy" target="_blank" class="nav__block nav__block--privacy">
        <span class="nav__block__span">privacy policy</span>
      </a>
      <a href="https://www.desivero.com/privacy-e-cookies" target="_blank" class="nav__block nav__block--cookies">
        <span class="nav__block__span">cookies policy</span>
      </a>
      <div class="nav__footer">
        <p>&copy; 2018 Desivero.com</p>
        <p>P.IVA 03733040988</p>
        <p>Tutti i diritti riservati</p>
      </div>
    </nav>
  </transition>
</template>

<script>
  export default{
    data(){
      return {
        phone: 'tel:0297190019'
      }
    },
    methods: {
      checkResolution(){
        var windowWidth = $(window).innerWidth();
        if (windowWidth >= 768) {
          this.phone = 'javascript:void(0)'
        }
        else {
          this.phone = 'tel:0297190019'
        }
      }
    },
    mounted(){
      $(window).on('resize', this.checkResolution);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/globals/Menu.vue